import Swiper from "swiper";
import {Pagination, Navigation, A11y, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";

const mixSlider = document.querySelectorAll('.mixcontent-slider-slider');

for( var i=0; i< mixSlider.length; i++ ) {
    mixSlider[i].classList.add('mixcontent-slider-container-' + i);
    
    const swiper = new Swiper('.mixcontent-slider-container-' + i + ' .mixcontent-slider-items', {
        modules: [Navigation, A11y, Pagination, Autoplay],
        speed: 2000,
        a11y: {
            enabled: true,
        },
        autoplay: {
            delay: 5000,
          },
        freeMode: false,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
    });
};

